import React from 'react';

/**
 * Parses text containing **highlighted** patterns and returns React elements
 * with glossary terms highlighted with a yellow background.
 *
 * @param {string} text - Text that may contain **word** patterns
 * @returns {React.ReactNode} - Text with highlighted spans for glossary terms
 */
export function renderWithGlossaryHighlights(text) {
    if (!text || typeof text !== 'string') {
        return text;
    }

    // Regex to match **text** patterns (non-greedy)
    const glossaryPattern = /\*\*(.+?)\*\*/g;

    // Check if there are any matches
    if (!glossaryPattern.test(text)) {
        return text;
    }

    // Reset regex lastIndex after test
    glossaryPattern.lastIndex = 0;

    const parts = [];
    let lastIndex = 0;
    let match;
    let keyIndex = 0;

    while ((match = glossaryPattern.exec(text)) !== null) {
        // Add text before the match
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }

        // Add highlighted glossary term
        parts.push(
            <span key={keyIndex++} className="glossary-highlight">
                {match[1]}
            </span>
        );

        lastIndex = match.index + match[0].length;
    }

    // Add remaining text after last match
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts.length > 0 ? parts : text;
}
